@for (app of apps; track app; let i = $index) {
  <div class="form-check">
    <label class="form-check-label">
      <input type="checkbox" class="me-2 form-check-input" [attr.data-cy]="'ApplicationsCheckbox_' + app.appUrlID"
        [value]="app.appUrlID" (change)="toggleAppUrlId(app.appUrlID)" />
      {{ app.label }}
    </label>
  </div>
}